/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import React from 'react';
import {DropdownMenu, IconButton} from '@radix-ui/themes';
import {useTheme} from '../../../../contexts/ThemeContext';
import {Tooltip, usePortalContainer} from '../Tooltip';
import UIStrings from '../../constants/UIStrings';
import ThemeIcon from './ThemeIcon';
import ThemeRadioGroup from './ThemeRadioGroup';

/**
 * ThemeSwitcher - Icon-only dropdown for choosing Light, Dark or System.
 * The trigger icon shows the saved choice, not the resolved theme, so a user on
 * System sees the monitor icon even when the OS is dark. Choosing an item is the
 * only thing that writes the preference to localStorage.
 */
export function ThemeSwitcher() {
  const {themePreference} = useTheme();
  const portalContainer = usePortalContainer();

  // The trigger shows the saved choice (themePreference), never activeTheme, so a
  // System user sees the monitor icon and a screen reader announces "Theme: System".
  const label = UIStrings.THEME.TRIGGER_LABEL[themePreference];

  return (
    <DropdownMenu.Root>
      <Tooltip content={label}>
        <DropdownMenu.Trigger>
          <IconButton
            variant="outline"
            size="2"
            color="gray"
            aria-label={label}
            data-testid="theme-switcher"
            data-analytics-id="nxrm-header-toggle-theme"
          >
            <ThemeIcon theme={themePreference} />
          </IconButton>
        </DropdownMenu.Trigger>
      </Tooltip>

      <DropdownMenu.Content align="end" container={portalContainer} color="gray" variant="soft">
        <ThemeRadioGroup testIdPrefix="theme-option" analyticsIdPrefix="nxrm-header-theme" />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}

export default ThemeSwitcher;
